import { SEO } from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Target, Lightbulb, Rocket, Award, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PublicProjectsPage = () => {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: <Lightbulb className="w-5 h-5 text-primary" />,
      title: "Identifica retos reales",
      description: "Trabaja en problemas de tu empresa con impacto medible"
    },
    {
      icon: <Rocket className="w-5 h-5 text-secondary" />,
      title: "Desarrolla soluciones con IA",
      description: "Implementa proyectos usando las herramientas más avanzadas"
    },
    {
      icon: <Award className="w-5 h-5 text-accent" />,
      title: "Obtén certificación",
      description: "Valida tus competencias con proyectos aplicados"
    }
  ];

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-6">
      <SEO
        title="Proyectos de IA aplicados — LÍDER IA"
        description="Transforma retos de negocio en soluciones de IA aplicadas y certifica tu capacidad de ejecución con proyectos reales."
        path="/challenge"
      />
      <div className="max-w-2xl w-full space-y-8">
        {/* Header */}
        <div className="text-center space-y-4">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-secondary/10 mb-4">
            <Target className="w-10 h-10 text-secondary" />
          </div>
          <h1 className="text-3xl font-bold text-foreground">
            Proyectos de IA
          </h1>
          <p className="text-lg text-muted-foreground max-w-md mx-auto">
            Transforma retos de negocio en soluciones de IA aplicadas y demuestra tu capacidad de ejecución
          </p>
        </div>

        {/* Benefits */}
        <Card className="border-border/50 bg-card/50 backdrop-blur">
          <CardHeader>
            <h2 className="text-lg font-semibold leading-none tracking-tight">¿Qué lograrás?</h2>
          </CardHeader>
          <CardContent className="space-y-4">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className="mt-0.5">{benefit.icon}</div>
                <div>
                  <p className="font-medium text-foreground">{benefit.title}</p>
                  <p className="text-sm text-muted-foreground">{benefit.description}</p>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        {/* CTA */}
        <Card className="border-2 border-secondary/20 bg-gradient-to-br from-secondary/5 to-primary/5">
          <CardContent className="pt-6 text-center space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary/10 text-secondary text-sm font-medium">
              <Lock className="w-4 h-4" />
              Contenido exclusivo para miembros
            </div>
            <CardDescription className="text-base">
              Regístrate gratis para acceder al módulo de proyectos y comenzar a construir soluciones
            </CardDescription>
            <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
              <Button 
                size="lg" 
                onClick={() => navigate("/auth")}
                className="gap-2"
              >
                Registrarme ahora
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                onClick={() => navigate("/auth")}
              >
                Ya tengo cuenta
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PublicProjectsPage;
